import React, { useEffect, useState } from "react";
import { Chart } from "react-google-charts";

const WorkOrderChart = ({ stats }) => {
  const data = [
    ["Task", "Count"],
    ["Completed", stats?.completed || 0],
    ["Ongoing", stats?.ongoing || 0],
    ["Pending", stats?.pending || 0],
  ];

  const isEmpty = !stats?.completed && !stats?.ongoing && !stats?.pending;

   const [offset, setOffset] = useState(0.02);
  
    useEffect(() => {
      const interval = setInterval(() => {
        setOffset((prev) => (prev === 0.02 ? 0.06 : 0.02));
      }, 1500); // smooth loop
  
      return () => clearInterval(interval);
    }, []);


const options = {
  pieHole: 0.55, // more modern donut
      1: { offset: 0.05 }, 

  colors: ["#00b894", "#9695ff", "#fdcb6e"],

  backgroundColor: "transparent",

  legend: {
    position: "bottom",
    alignment: "center",
    textStyle: {
      fontSize: 11,
      color: "#2d3436",
      bold: true,
    },
  },

  chartArea: {
    width: "88%",
    height: "78%",
  },

  pieSliceText: "percentage",

  pieSliceBorderColor: "#ffffff",

slices: {
      0: { offset: offset / 0 },
      1: { offset: offset / 0 },
      2: { offset: offset / 0.9 },
    },

  tooltip: {
    text: "both",
    showColorCode: true,
  },

  animation: {
    startup: true,
    duration: 1200,
    easing: "out",
  },

  is3D: true,
  fontName: "lato",
  pieSliceTextStyle: {
    color: "#ffffff",
    fontSize: 12,
  },
};


  return (
    <div style={styles.card}>
      <div style={styles.header}>📊 Work Order Status</div>

      <div style={styles.chartWrapper}>
        {isEmpty ? (
          <div style={styles.emptyState}>
            <div style={{ fontSize: '40px', marginBottom: '10px' }}>📋</div>
            No Data Available
          </div>
        ) : (
          <Chart
            chartType="PieChart"
            data={data}
            options={options}
            width="100%"
            height="300px"
          />
        )}
      </div>
    </div>
  );
};

export default WorkOrderChart;

// 💅 Styles
const styles = {
  card: {
    width: "100%",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "10px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.08)",
    transition: "transform 0.3s ease, box-shadow 0.3s ease",
  },

  header: {
    fontSize: "15px",
    fontWeight: "600",
    color: "#2d3436",
  },

  chartWrapper: {
    animation: "fadeIn 1s ease-in-out",
    minHeight: "300px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    color: "#b2bec3",
    fontSize: "14px",
    fontWeight: "500",
    textAlign: "center",
  },

  footer: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: "8px",
  },

  badge: {
    padding: "6px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "500",
  },
};